import * as fromReducer from './shared-content.reducers';
import type { ISharedContentState } from './shared-content.reducers';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const getDocumentsState = createFeatureSelector<ISharedContentState>('documents');

export const getSharedContent = createSelector(getDocumentsState, fromReducer.getSharedContent);

export const getSharedContentActionState = createSelector(
  getDocumentsState,
  fromReducer.getSharedContentActionState
);

export const getUnread = createSelector(getDocumentsState, fromReducer.getUnread);

export const getUnreadActionState = createSelector(
  getDocumentsState,
  fromReducer.getUnreadActionState
);

export const getMigrateDocumentsActionState = createSelector(
  getDocumentsState,
  fromReducer.getMigrateDocumentsActionState
);
